export default __webpack_public_path__ + "static/media/480_business02-it-mobile.3cf2a069.png";